export default __webpack_public_path__ + "static/media/download-google.fbb61184.png";